import React, { Component } from 'react'
import { RechargePhone } from './RechargePhone'
import { BillPayment } from './BillPayment'
import { FuelCredit } from './FuelCredit'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'

import ServicesPlaceholder from './ServicesPlaceholder'
import ReactPlaceholder from 'react-placeholder'
import 'react-placeholder/lib/reactPlaceholder.css'
import '@loyal_template/showcases.css'

const RechargePhoneId = 71
const BillPaymentId = 21188
const FuelCreditId = 117
class Services extends Component {
  render () {
    let hasRechargePhone = this.props.services.find(
      s => s.supplierId === RechargePhoneId
    )
    let hasBillPayment = this.props.services.find(
      s => s.supplierId === BillPaymentId
    )
    let hasFuelCredit = this.props.services.find(
      s => s.supplierId === FuelCreditId
    )

    if (hasRechargePhone || hasBillPayment || hasFuelCredit) {
      return (
        <ReactPlaceholder ready customPlaceholder={<ServicesPlaceholder />}>
          <div className='container-services container-fluid bg-brand-4 blue-area py-0 py-md-4'>
            <div className='container'>
              <div className='row'>
                <div className='col-12 mx-1 mb-2 px-0 d-lg-block d-none'>
                  <h2 className='txt-font-title color-ui-white'>
                    Aproveite serviços exclusivos.
                  </h2>
                </div>
                <div className='col-12 mx-1 mb-2 px-0 d-lg-none d-block'>
                  <h2 className='txt-font-title color-ui-white mt-2'>Serviços</h2>
                </div>
              </div>
              <div className='row'>
                {hasRechargePhone ? <RechargePhone /> : ''}
                {hasBillPayment ? <BillPayment /> : ''}
                {hasFuelCredit ? <FuelCredit /> : ''}
              </div>
            </div>
          </div>
        </ReactPlaceholder>
      )
    }
    return ''
  }
}

const mapStateToProps = ({ stores: { services } }) => ({ services })

Services.propTypes = {
  services: PropTypes.array
}

export default connect(
  mapStateToProps,
  null
)(Services)



// WEBPACK FOOTER //
// ./src/features/Services/Services.js